var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('book-carousel-pop-up',{staticClass:"popular",attrs:{"titleCarousel":_vm.$t('library.title_carousel_2'),"subTitleCarousel":_vm.$t('library.subtitle_carousel_2'),"booksList":_vm.topMostRequestedBooksList,"mostPopular":true}})}
var staticRenderFns = []

export { render, staticRenderFns }